import React from "react";
import { Link } from "react-router-dom";
import { InstagramLogo, TiktokLogo, EnvelopeSimple } from "@phosphor-icons/react";
import { CONTACT, IMAGES } from "@/data/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A1521] border-t border-[#F6F4F0]/10">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="mb-6">
            <img src={IMAGES.logo} alt="4PS Marketing" className="h-28 w-auto object-contain" />
          </div>
          <p className="font-heading italic text-2xl text-gold leading-snug max-w-sm">
            Passion. Produce. Promote. Profit.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[#6B7280] mb-5">Explore</p>
          <ul className="space-y-3 text-sm text-[#E5E7EB]">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><Link to="/consultation" className="hover:text-gold transition-colors">Book Consultation</Link></li>
            <li><Link to="/admin/login" className="hover:text-gold transition-colors">Team Login</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] text-[#6B7280] mb-5">Connect</p>
          <a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sm text-[#E5E7EB] hover:text-gold transition-colors mb-4 break-all">
            <EnvelopeSimple size={20} className="text-gold shrink-0" /> {CONTACT.email}
          </a>
          <a data-testid="footer-instagram" href={`https://instagram.com/${CONTACT.instagram}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm text-[#E5E7EB] hover:text-gold transition-colors mb-4">
            <InstagramLogo size={20} className="text-gold" /> @{CONTACT.instagram}
          </a>
          <a data-testid="footer-tiktok" href={`https://tiktok.com/@${CONTACT.tiktok}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm text-[#E5E7EB] hover:text-gold transition-colors">
            <TiktokLogo size={20} className="text-gold" /> @{CONTACT.tiktok}
          </a>
        </div>
      </div>

      <div className="hairline mt-16 pt-8 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#6B7280]">
        <span>© 2026 4PS Marketing Group LLC. All rights reserved.</span>
        <span className="uppercase tracking-[0.2em]">In-person filming by appointment · 2:30–7:30</span>
      </div>
    </div>
  </footer>
);
